import { useEffect } from 'react';
import { Outlet, useLocation } from 'react-router-dom';

import { useRepository } from '@/Application/Providers/Repository';
import { getCookie } from '@/modules/perseo-billing/hooks';
import { useDeviceParam } from '@/modules/perseo-billing/hooks/use-device-params';
import { Header } from '@/Pages/MainLayout/partials/Header';
import RegionProvider from '@/sections/region/RegionContext';

const MainLayout = () => {
  const location = useLocation();
  const isOrderConfirmation = location.pathname.includes('/processing');
  const mainClass = isOrderConfirmation
    ? 'co-mx-auto'
    : 'co-mx-auto co-pt-[12px] tablet_w:co-pt-8';
  const { regions: regionsRepository } = useRepository();

  useDeviceParam();

  useEffect(() => {
    const tokenUserID = getCookie('tokenUserId');
    window.cnstrcUserId = tokenUserID;
  }, []);

  return (
    <RegionProvider repository={regionsRepository}>
      <div className="co-flex co-flex-col">
        {!isOrderConfirmation && <Header />}
        <div className={mainClass}>
          <Outlet />
        </div>
      </div>
    </RegionProvider>
  );
};

export default MainLayout;
